import { zoneReducer } from "../reducer/ZoneReducer";

export const reducer = zoneReducer;
